import { FC } from 'react'
import OverigeDataView from './OverigeDataView'

const OverigeDataStadList: FC = () => <OverigeDataView mode="stad" />

export default OverigeDataStadList
